export const nonAsciiEscape = str => {
    if (typeof str !== 'string') {
        return str;
    }

    return str
        .split('')
        .map(char => {
            const charCode = char.charCodeAt(0);
            return charCode > 127 ? '' : char;
        })
        .join('');
};
